export function getValueOrDefault(value: string | null | undefined, defaultValue: string): string {
  if (!value || value.trim() === '') {
    return defaultValue;
  }
  return value;
}
